const contactText = document.querySelector('.contact__text');
const buttonContact = document.querySelector('.button__contact');

buttonContact.addEventListener('click', function () {

    gsap.to(aboutText, { autoAlpha: 0, duration: 1, ease: "power3.inOut" });

    if (contactText.style.opacity = '0') {
        gsap.to(contactText, { autoAlpha: 1, duration: 1, ease: "power3.inOut" })
        gsap.to(buttonContact, { filter: 'blur(2px)', duration: 0.5, ease: "power3.inOut" })
        gsap.to(buttonAbout, { filter: 'blur(0px)', duration: 0.5, ease: "power3.inOut" })

    } else if (contactText.style.opacity = '1') {
        gsap.to(contactText, { autoAlpha: 0, duration: 1, ease: "power3.inOut" })
    }
})

contactText.addEventListener('click', function () {
    gsap.to(contactText, { autoAlpha: 0, duration: 1, ease: "power3.inOut" })
    gsap.to(aboutText, { autoAlpha: 0, duration: 1, ease: "power3.inOut" })
    gsap.to(buttonAbout, { filter: 'blur(0px)', duration: 0.5, ease: "power3.inOut" })
    gsap.to(buttonContact, { filter: 'blur(0px)', duration: 0.5, ease: "power3.inOut" })
})

const aboutText = document.querySelector('.about__text');
const buttonAbout = document.querySelector('.button__about');

buttonAbout.addEventListener('click', function () {

    gsap.to(contactText, { autoAlpha: 0, duration: 1, ease: "power3.inOut" });

    if (aboutText.style.opacity = '0') {
        gsap.to(aboutText, { autoAlpha: 1, duration: 1, ease: "power3.inOut" })
        gsap.to(buttonContact, { filter: 'blur(0px)', duration: 0.5, ease: "power3.inOut" })
        gsap.to(buttonAbout, { filter: 'blur(2px)', duration: 0.5, ease: "power3.inOut" })

    } else if (aboutText.style.opacity = '1') {
        gsap.to(aboutText, { autoAlpha: 0, duration: 1, ease: "power3.inOut" })
    }
})

aboutText.addEventListener('click', function () {
    gsap.to(aboutText, { autoAlpha: 0, duration: 1, ease: "power3.inOut" })
    gsap.to(contactText, { autoAlpha: 0, duration: 1, ease: "power3.inOut" })
    gsap.to(buttonAbout, { filter: 'blur(0px)', duration: 0.5, ease: "power3.inOut" })
    gsap.to(buttonContact, { filter: 'blur(0px)', duration: 0.5, ease: "power3.inOut" })
})
